async function jget(url) {
    const r = await fetch(url, {
        headers: { 'ngrok-skip-browser-warning': 'true' },
        cache: 'no-store'
    });

    const ct = r.headers.get('content-type') || '';
    if (ct.includes('text/html')) {
        const text = await r.text();
        if (text.includes('ERR_NGROK_6024')) {
            throw new Error('Ngrok warning page. Заголовок не прошёл. Проверь proxy и заголовок.');
        }
        throw new Error('Unexpected HTML from server');
    }

    const j = await r.json();
    if (!r.ok || j.ok === false) throw new Error(j.error || `HTTP ${r.status}`);
    return j;
}

export async function apiActivateTrial(telegramId, username) {
  const r = await fetch('/api/user/activate-trial', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true'
    },
    body: JSON.stringify({ telegramId, username })
  });
  const j = await r.json();
  if (!r.ok || j.ok === false) throw new Error(j.error || 'Ошибка активации');
  return j;
}

export async function apiGetUserByTelegram(telegramId) {
    const j = await jget(`/api/user/by-telegram?telegramId=${Number(telegramId)}`);
    return j.user || null;
}

export async function apiGetUsage(uuid, fromISO, toISO) {
    const u = new URL(`/api/user/usage`, window.location.origin);
    u.searchParams.set('uuid', uuid);
    u.searchParams.set('from', fromISO);
    u.searchParams.set('to', toISO);
    const j = await jget(u.toString());
    return j.usage || [];
}
